import { appAxios } from "@/core/utils/appAxios";
import {
    APIResponse,
    PaymentDto,
    PaymentMollieMetadataDto,
    PaymentType,
    PostOrderPaymentsRequestBody,
} from "@/shared/api-contract/api-contract";
import { Options, Vue } from "vue-class-component";
import { Model } from "vue-property-decorator";
import { AxiosResponse } from "axios";
import ManualTransferConfirmPopup from "@/dashboard/my-orders/new-popup/manual-transfer-confirm-popup/manual-transfer-confirm-popup.vue";
import ManualTransferPopup from "@/dashboard/my-orders/new-popup/manual-transfer-popup/manual-transfer-popup.vue";

@Options({
    components: {
        ManualTransferConfirmPopup,
        ManualTransferPopup,
    },
})
export class PaymentPopup extends Vue {
    @Model("_orderId", { required: true })
    orderId!: number;
    @Model("_vehiclesId", { required: true, default: [] })
    vehiclesId!: string[];
    paymentMollieMetadata: PaymentMollieMetadataDto | null = null;
    paymentDto: PaymentDto[] = [];
    mollieLoading = false;
    isLoadingData = true;

    /** show manual payment confirm popup */
    isShowConfirmPopup = false;
    /** show manual payment final popup (after payment) */
    isShowFinalPopup = false;

    closePopup() {
        this.$emit("close");
    }

    async selectManual() {
        this.isShowConfirmPopup = true;
    }

    goBack() {
        this.isShowConfirmPopup = false;
    }

    confirm() {
        this.isShowConfirmPopup = false;
        this.isShowFinalPopup = true;
    }

    confirmOnlinePayment() {
        this.fetchOrderPayments(this.orderId, this.vehiclesId, PaymentType.Mollie);
    }

    async fetchOrderPayments(
        orderId: number,
        vehiclesId: string[],
        paymentType: PaymentType,
    ) {
        this.postOrderPayments(orderId, vehiclesId, paymentType)
            .then((paymentDtos) => {
                if (
                    paymentDtos &&
                    paymentType !== PaymentType["Manual Transfer"] &&
                    paymentDtos.length > 0 &&
                    paymentDtos[0].id
                ) {
                    this.paymentDto = paymentDtos;
                    this.mollieLoading = true;
                    this.startMollieMetadataPolling(orderId, paymentDtos[0].id);
                }
            })
            .catch((error) =>
                console.error(`Fetch order payments Order #${orderId} error:`, error),
            );
    }

    async postOrderPayments(
        orderId: number,
        vehiclesId: string[],
        paymentType: PaymentType,
    ): Promise<PaymentDto[] | void> {
        const payload: PostOrderPaymentsRequestBody = {
            id_payment_type: paymentType,
            ids_order_vehicles: vehiclesId,
        };
        const response = await appAxios.value
            .post<APIResponse<PaymentDto[]>>(
                `/client/web/orders/${orderId}/payments`,
                payload,
            )
            .then((resp) => {
                if (paymentType === PaymentType["Manual Transfer"]) return resp;
                if (!resp.data.data[0].id) return;
                this.mollieLoading = true;
                let countDown = 5;
                const timerId = setInterval(() => {
                    if (countDown === 0) {
                        clearInterval(timerId);
                        this.mollieLoading = false;
                        return;
                    }
                    this.fetchMollieMetadata(orderId, resp.data.data[0].id, countDown > 1)
                        .then((resp) => {
                            if (resp?.data.status.code == 200) {
                                countDown = 0;
                                if (resp?.data?.data?.checkout_url_href) {
                                    window.location.replace(
                                        resp?.data?.data?.checkout_url_href,
                                    );
                                }
                            }
                        })
                        .catch((res) =>
                            console.log(
                                `Fetch mollie timerId=${timerId} metadata Order #${orderId} error:`,
                                res,
                            ),
                        );
                    countDown = countDown - 1;
                }, 5000);
            })
            .catch((res) =>
                console.log(`Fetch order payments Order #${orderId} error:`, res),
            );
        return response?.data.data;
    }

    async fetchMollieMetadata(
        orderId: number,
        paymentId: bigint,
        skipErrorHandler?: boolean,
    ): Promise<AxiosResponse<APIResponse<PaymentMollieMetadataDto>>> {
        return appAxios.value.get<APIResponse<PaymentMollieMetadataDto>>(
            `/client/web/orders/${orderId}/payments/${paymentId}/mollie-metadata`,
            {
                headers: {
                    "X-Skip-Error-Handler": skipErrorHandler ? "true" : "false",
                },
            },
        );
    }

    startMollieMetadataPolling(orderId: number, paymentId: bigint) {
        let countDown = 5;
        const timerId = setInterval(() => {
            if (countDown === 0) {
                clearInterval(timerId);
                this.mollieLoading = false;
                return;
            }
            this.fetchMollieMetadata(orderId, paymentId)
                .then((resp) => {
                    if (resp?.data.status.code === 200) {
                        countDown = 0;
                        window.open(
                            `${this.paymentMollieMetadata?.checkout_url_href}`,
                            "_blank",
                        );
                    }
                })
                .catch((error) => {
                    console.error(
                        `Fetch mollie timerId=${timerId} metadata Order #${orderId} error:`,
                        error,
                    );
                });
            countDown = countDown - 1;
        }, 5000);
    }
}
